import { CldImage } from "next-cloudinary";
import SectionTitle from "components/typography/SectionTitle/SectionTitle";
import SafeMarkdown from "components/ui/SafeMarkdown/SafeMarkdown";
import styles from "./OurStory.module.scss";

const OurStory = ({ about }) => {
  return (
    <div className={`${styles.ourStory} variable-container`} id="our-story">
      <h2 className={`${styles.sectionTitle}`}>
        <SectionTitle title="Our Story" />
      </h2>
      <div className={`${styles.container}`}>
        <CldImage
          src={about?.ourStoryImage?.data?.attributes?.url}
          alt={about?.ourStoryImageAlt ?? "Our story image"}
          width="515"
          height="655"
          loading="lazy"
          className={`${styles.imageWrapper}`}
        />
        <SafeMarkdown
          options={{ forceInline: true, wrapper: "span" }}
          className={`${styles.text1}`}
        >
          {about?.ourStoryTextPart1}
        </SafeMarkdown>
        <SafeMarkdown options={{ forceInline: true, wrapper: "span" }}>
          {about?.ourStoryTextPart2}
        </SafeMarkdown>
      </div>
      <div style={{ clear: "both" }}></div>
    </div>
  );
};

export default OurStory;
